import ProjectBlock, { ProjectBlockProps } from '@/components/HomePage/ProjectBlocks/ProjectBlock';
import './Presentation.css';
import DecoratedText from '@/components/DecoratedText/DecoratedText';

const projects: ProjectBlockProps[] = [
	{
		title: '"Chroma Lab Experiment"',
		subtitle: 'Video Game Development in Unreal Engine',
		link: '/Chroma_Lab_Experiment',
		background: '/Img/chromaLabBG.png',
		images: [
			"/Img/CompLogo/Unreal.png",
			"/Img/CompLogo/Blender.png",
			"/Img/CompLogo/Audition.png",
			"/Img/CompLogo/Substance painter.png",
			"/Img/CompLogo/AfterEffect.png",
		],
	},
	{
		title: '"Ouch" by BMTH',
		subtitle: 'Music Video in Blender',
		link: '/ouch',
		background: '/Img/OuchBG.png',
		images: [
			"/Img/CompLogo/Blender.png",
			"/Img/CompLogo/AfterEffect.png"
		]
	},
	{
		title: '"Alice in the Wonderland"',
		subtitle: 'Animation in After Effects',
		link: '/alice',
		background: '/Img/AliceBG.png',
		images: [
			"/Img/CompLogo/Audition.png",
			"/Img/CompLogo/AfterEffect.png",
			"/Img/CompLogo/Illustrator.png",
		]
	},
	{
		title: '"HSE Fonts"',
		subtitle: 'Animation in After Effects',
		link: '/HSEFonts',
		background: '/Img/HSEFonts.png',
		images: [
			"/Img/CompLogo/AfterEffect.png",
			"/Img/CompLogo/Illustrator.png",
		]
	},
	{
		title: '"Blumhouse Productions"',
		subtitle: 'Movie opening in Blender',
		link: '/Blumhouse',
		background: '/Img/Blumhouse.png',
		images: [
			"/Img/CompLogo/Blender.png",
			"/Img/CompLogo/AfterEffect.png",
		]
	},
];

export default function Presentation() {
	return (
		<div className='presentation-container'>
			<div>
				<h1 className="blue-text presentation">
					<DecoratedText
						text="my works"
						decoratedIndex={7}
						imageSrc={"/Img/Pigeons/paint-pigeon.png"}
					/>
				</h1>
			</div>
			<div className='project-container'>
				{projects.map((prj) => (
					<ProjectBlock
						title={prj.title}
						subtitle={prj.subtitle}
						images={prj.images}
						background={prj.background}
						link={prj.link} />
				))}
			</div>
		</div>
	);
}
